import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {Prestation} from '../../../prestations/shared/model/prestation.model';

@Injectable()
export class PrestationsReleasedResolver implements Resolve<Observable<Prestation[]>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<Prestation[]> {
    return this.facadeService.getPagePrestationReleased(0, 25).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
